export default function Button({
  children,
  className,
  bgColor,
  isOpen,
  setIsOpen
}) {
  return (
    <button
      className={`flex items-center gap-3 bg-${
        bgColor ? "bgColor" : "primary"
      } shadow-3 rounded-lg px-4 py-2 font-semibold ${className} `}
      onClick={() => setIsOpen && setIsOpen(!isOpen)}
    >
      {children}
    </button>
  )
}
